import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = {
  class: "d-flex fl-ev"
};
var _hoisted_3 = {
  class: "d-flex fl-j-e w-100"
};
var _hoisted_4 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_button = _resolveComponent("el-button");

  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_table = _resolveComponent("el-table");

  var _component_el_scrollbar = _resolveComponent("el-scrollbar");

  return _ctx.getCustomersList.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_scrollbar, {
    "max-height": _ctx.maxHeight
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_table, {
        ref: "table",
        stripe: "",
        data: _ctx.getCustomersList,
        height: "500"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_table_column, {
            prop: "email",
            label: _ctx.$t('columns.email-address'),
            "show-overflow-tooltip": "",
            "min-width": "230"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "fullName",
            label: _ctx.$t('columns.full-name'),
            "show-overflow-tooltip": "",
            "min-width": "260"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "countryString",
            label: _ctx.$t('customer.country'),
            "show-overflow-tooltip": "",
            "min-width": "180"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "city",
            label: _ctx.$t('customer.city'),
            "show-overflow-tooltip": "",
            "min-width": "180"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "zipCode",
            label: _ctx.$t('field.zip-code'),
            "show-overflow-tooltip": "",
            "min-width": "180"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "phone",
            label: _ctx.$t('columns.phone-number'),
            "show-overflow-tooltip": "",
            "min-width": "180"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "checkOrder",
            "show-overflow-tooltip": "",
            "min-width": "180",
            fixed: "right"
          }, {
            default: _withCtx(function (scope) {
              return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
                type: scope.row.checkOrder ? 'primary' : 'default',
                onClick: function onClick($event) {
                  return _ctx.onSelect(scope.$index, scope.row);
                }
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(scope.row.checkOrder ? _ctx.$t("button.unselect") : _ctx.$t("button.select")), 1)];
                }),
                _: 2
              }, 1032, ["type", "onClick"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
                class: "d-flex fl-j-c fl-col",
                onClick: function onClick($event) {
                  return _ctx.editCustomer(scope.$index, scope.row);
                }
              }, [_createVNode(_component_SvgIcon, {
                iconContent: _ctx.iconContent,
                iconAlt: _ctx.iconAlt,
                iconStyle: _ctx.iconStyle
              }, null, 8, ["iconContent", "iconAlt", "iconStyle"])], 8, _hoisted_4)])])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["data"])];
    }),
    _: 1
  }, 8, ["max-height"])])) : _createCommentVNode("", true);
}